var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-sm-and-up bg"},[_c('div',{staticClass:"navigate_wrap"}),_c('div',{staticClass:"mobile_callme_wrap"},[_c('p',[_vm._v(" Copyright ©2025 广州真卫士数码科技有限公司 . All Rights Reserved . ")])])])
}]

export { render, staticRenderFns }